import { Component, OnInit } from '@angular/core';
import { FincasApiService } from '../../../../../service/api/fincas-api.service';
import { DashboardService } from '../../../../../service/events/dashboard.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseForm } from '../../../../base-form';
import {
    build,
    pool,
} from '../../../../../common/classes/request-builder';
import { environment } from '../../../../../../environments/environment';
import { ClientesApiService } from 'src/app/service/api/clientes-api.service';

import { HttpStatusCode } from '@angular/common/http';

import { CRMApiService } from 'src/app/service/api/crm.service';

import { CrmModel } from 'src/app/models/crm/crm.model';
import { CRMFormDefinition } from './fields/formfields';
import { ReactiveFormRequestCoordinator } from 'src/app/common/components/reactive-form-builder/form-request-flow.coordinator';
import { ReactiveFormChangedField, ReactiveFormValue } from 'src/app/common/components/reactive-form-builder/interfaces/reactive-form-change.interface';

@Component({
    selector: 'app-crm-form',
    standalone: false,
    templateUrl: './crm-form.component.html',
    styleUrls: ['./crm-form.component.scss'],
})
export class CrmFormComponent extends BaseForm<CrmModel> implements OnInit {
    /** Reactive form definition bound to the template */
    public form!: CRMFormDefinition;

    /** Form request engine (phase-based hooks) */
    public readonly formRequest = new ReactiveFormRequestCoordinator<CrmModel>;

    /** Expose enums/tokens to the template */
    public readonly HTTP = HttpStatusCode;


    public serverUrl = environment.serverUrl;


    visible = false;

    constructor(
        public override route: ActivatedRoute,
        public override router: Router,
        public fincasApi: FincasApiService,
        private readonly clientesApi: ClientesApiService,
        public override dashboard: DashboardService,
        public readonly crmApiService: CRMApiService,
    ) {
        super(
            route,
            router,
            dashboard,
            crmApiService.CRM.PUT,
            crmApiService.CRM.POST,
            'crm',
            'Editar Tarea comercial',
            'Crear Tarea comercial'
        );
        this.formRequest = new ReactiveFormRequestCoordinator<CrmModel>;
    }

    ngOnInit(): void {
        this.dropdownsFinalized = false;
        const type = this.getType();
        const baseModel = this.getModel() as unknown as Record<string, string>;
        
        this.form = new CRMFormDefinition(type, baseModel, null);
        this.softInit(this.getType());
        this.initFormData();
    }

    public formChanges(formModel: ReactiveFormValue<CrmModel>, lastChangedFieldName: ReactiveFormChangedField<CrmModel>): void {
        this.form.model = formModel;
        this.form.tag = lastChangedFieldName;
    }

    private initFormData(): Promise<boolean> {
        const builds = [
            build(this.clientesApi.clientesGET, this.form.clientes,
                (it: { nombre: string; telefono: string }) => it.nombre + ' (Teléfono: ' + (it.telefono || '') + ')',
                false, false),
        ];

        // Common notifier: run in a microtask to mirror async pool completion timing
            const notify = (): void => { queueMicrotask(() => { 
                this.dropdownsFinalized = true;
                this.dropdownLoadTrigger.next(); 
            }); };
        
            // No tasks -> fire trigger efficiently and resolve
            if (builds.length === 0) {
              notify();
              return Promise.resolve(true);
            }
        
            // Tasks exist -> fire trigger after pool resolves
            return pool(builds, notify);
    }
}